{
  "heading": "Language",
  "referenceOffOption": "Off",
  "fallbackOption": "English - default",
  "labels": {
    "editingLocaleDropdown": "Editing",
    "referenceLocaleDropdown": "Reference"
  },
  "links": {
    "reset": "Reset"
  }
}
